export enum UpdateItemNumberType {
  UpdateOnly = 1,
  UpdateAndReplace = 2
}
